import {
  type GetSalaryHistoryAPIResponse,
  SalaryChangeRequestStatus,
  type SalaryHistoryEntry,
  salaryHistoryNamespace,
} from '@omnipresentgroup/types';

export const generateSalaryHistory = (
  override: Partial<SalaryHistoryEntry> = {},
) => ({
  ...DEFAULT_SALARY_HISTORY,
  ...override,
});

export const DEFAULT_SALARY_HISTORY: SalaryHistoryEntry = {
  employeeId: '9a666a45-e49b-4dbd-88c2-7bcbf1d1d0f5',
  employeeName: 'Lat Via',
  previousSalary: {
    amount: 900,
    currency: 'EUR',
  },
  newSalary: {
    amount: 1000,
    currency: 'EUR',
  },
  requestedAt: '2022-11-08T11:35:29.302Z',
  reason: 'Promotion',
  effectiveDate: '2023-04-01',
  status: SalaryChangeRequestStatus.REQUESTED,
};

export const DEFAULT_GET_SALARY_HISTORY_RESPONSE: GetSalaryHistoryAPIResponse =
  {
    [salaryHistoryNamespace]: [
      DEFAULT_SALARY_HISTORY,
      generateSalaryHistory({
        effectiveDate: '2023-05-01',
        previousSalary: {
          amount: 1000,
          currency: 'EUR',
        },
        newSalary: {
          amount: 2000,
          currency: 'EUR',
        },
        reason: 'Promotion',
        requestedAt: '2023-04-28T14:50:35.202Z',
      }),
    ],
  };
